var AbstractWS = require("./AbstractWS");

function EndServiceTransactionWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.method('POST');
  self.name = 'EndServiceTransactionWS';


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/serviceTransaction/end';
  });


	/**
	 * Abstract override
	 * Allows the service results to be added
	 *
	 * @method doRequest
	 * @param {Function} fCallback
	 * @returns none
	 */
  self.doRequest = function (fCallback) {
    var serviceResultValues = self.parent.serviceResultVM.serviceValues();

    serviceResultValues.forEach(function (val, idx) {
      if (idx < 10) {
        self.addParam('details-' + idx, val);
      }
    });

    return AbstractWS.prototype.doRequest.call(self, fCallback);
  };


	/**
	 * DESCRIPTION
	 *
	 * @method processData
	 * @param {XMLString} xmlData
	 * @returns {EndServiceTransactionWS}
	 */
  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    // Clear the endServiceSessionId of the viewmodel
    vm.endServiceSessionId(null)

    // Return self (CheckStationWS) to be chainable, for best practice
    return self;
  };

  return self;
};

Object.setPrototypeOf(EndServiceTransactionWS.prototype, AbstractWS.prototype)
EndServiceTransactionWS.prototype.constructor = EndServiceTransactionWS;

module.exports = EndServiceTransactionWS
